import { Component, OnInit  } from '@angular/core';
import { LoadingService } from './loading.service';
import { NotificationHandlerService } from '../notifications/notification-handler.service';

@Component({
    selector: 'loading',
    templateUrl: 'loading.component.html'
})

export class LoadingComponent implements OnInit {

    public showLoading: boolean;

    constructor(
        private _loadingService: LoadingService,
        private _notificationService: NotificationHandlerService) {
    }

    ngOnInit(): void {
        this._loadingService.isLoading.subscribe((result: boolean) => {
            this._notificationService.logConsoleInfo('Loading service recieved: ' + result);
            this.showLoading = result;
        });
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/loading/loading.component.ts